import React, { PropsWithChildren } from "react";
import { useAuth } from "./AuthContext";
import UserAuthenticated from "./UserAuthenticated";
import { Navigate, Outlet, useParams } from "react-router-dom-v5-compat";

type ProtectedRouteProps = PropsWithChildren<{
    permissions?: string[];
}>;

const ProtectedRoute: React.FC<ProtectedRouteProps> = (props: ProtectedRouteProps) => {
    const { isAuthenticated } = useAuth();
    const params = useParams<{ idRistorante: string }>();
    if (!isAuthenticated) {
        return <Navigate to="/login" />;
    }

    const { idRistorante } = params;
    if (!idRistorante) {
        return <Navigate to="/login" />;
    }
    const isIncluded = UserAuthenticated.getInstance().ristoranteIdList.includes(idRistorante);
    if (!isIncluded) {
        return <Navigate to="/login" />;
    }

    if (props.permissions) {
        const hasPermission = props.permissions.some((permission) =>
            (UserAuthenticated.getInstance() as any)[permission] === true
        );
        if (!hasPermission) {
            return <Navigate to="/login" />;
        }
    }

    return <Outlet />;
};

export default ProtectedRoute;